import * as React from 'react';
import { FunctionComponent } from 'react';
import { QUESTIONS_TEMPLATE_TYPE } from 'Src/consts/message';
import { FormAnswersSummary } from '../FormAnswersSummary/FormAnswersSummary';
import { answersToMap } from 'Src/helpers/form/formRuntime';
import { getLastResponseUpdatedAtText, getRespondedAtText, getResponseUserText } from 'Src/helpers/message/message';

interface Props {
  message: any;
}

export const TournamentConfirmationRequestSummary: FunctionComponent<Props> = props => {
  const { message } = props;
  const fields = message.fields || [];
  const responseMeta = (
    <div className="mb-2 text-muted">
      <div><strong>Responded by:</strong> {getResponseUserText(message) || '—'}</div>
      <div><strong>Responded at:</strong> {getRespondedAtText(message) || '—'}</div>
      <div><strong>Last changed:</strong> {getLastResponseUpdatedAtText(message) || '—'}</div>
    </div>
  );

  if (message.formDefinition) {
    return (
      <>
        {responseMeta}
        <FormAnswersSummary
              definition={message.formDefinition}
              answers={answersToMap(message.formAnswers || [])}
            />
      </>
    );
  }

  const rows = fields.map((field, index) => {
    const { heading, value, type } = field;

    const isExistValue = typeof value !== 'undefined';

    let valueConverted;

    switch (type) {
      case QUESTIONS_TEMPLATE_TYPE.NUMBER:
      case QUESTIONS_TEMPLATE_TYPE.STRING:
      case QUESTIONS_TEMPLATE_TYPE.ENUM:
        valueConverted = value;

        break;
      case QUESTIONS_TEMPLATE_TYPE.BOOLEAN:
        if (isExistValue) {
          if (typeof value === 'boolean') {
            valueConverted = value ? 'Yes' : 'No';
          } else {
            valueConverted = value === 'true' ? 'Yes' : 'No';
          }
        } else {
          valueConverted = '';
        }

        break;
    }

    return (
      <tr key={`tournament_confirmation_request_${index}`}>
        <td>{heading}</td>
        <td>{valueConverted}</td>
      </tr>
    );
  });

  return (
    <>
      {responseMeta}
      <table className={'table table-sm mPreWrap'}>
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

TournamentConfirmationRequestSummary.displayName = 'TournamentConfirmationRequestSummary';
